import $ from "jquery";
import { checkNested, getConfig, UpdateQueryString } from "./general_functions.js";
import dayjs from "dayjs";
import language from "./translation";

/* global config, getUrlAttr, searchEngine */
var config, hits__pr__page, hits__from, sort__order, next__page, prev__page, query__text, filterText, scrollTimer;

export const doSearch = (searchOn) => {
    config = getConfig();
    query__text = decodeURIComponent(searchOn);
    filterText = getUrlAttr("filter");
    hits__pr__page = config.hits__pr__page || 20;
    hits__from = getUrlAttr("hits__from") || 0;
    sort__order = getUrlAttr("sort__order") || "RELEVANCE";

    next__page = Number(hits__from) + Number(hits__pr__page);
    prev__page = Number(hits__from) - Number(hits__pr__page);

    // categories: [
    //   { values: ["SubscriptionId", "${config.clientId}"] },
    //   { values: ["SubscriptionId", "9ba61978-b4d4-4763-9476-a5112aad4380"] }
    // ]

    //resize events
    $(window).on("resize", function() {
        if ($(this).width() < 768) {
            $(".searchresult__meta__count").insertBefore($('.categories'));
        }
        else {
            $(".searchresult__meta__count").appendTo($('.searchresult__meta > .row > div:first-child '));
        }
    });

    //search query field key pressed
    $("html").on("keypress", "#searchheader__inputfield", function(e) {
        if (e.keyCode == 13 && $(this).val().length > 0) {
            e.preventDefault();
            parent.location = "/search/" + $(this).val() + "?sok=" + $(this).val();
        }
    });
    //Search button click
    $("html").on("click", ".searchheader__search-button", function(e) {
        parent.location = "/search/" + $(".searchheader__inputfield").val() + "?sok=" + $(".searchheader__inputfield").val();
    });
    //Category group header Click
    $("html").on("click", ".categories__listheader", function(e) {
        $(this).toggleClass("closed");
        $(this).parent().find(".categories__listgroup").toggle();
    });
    //Category click
    $("html").on("click", ".categories__listitem input", function(e) {
        filterText = "";
        $.each($("input.categories__listcheck:checked"), function() {
            filterText += $(this).attr("data-category_select") + ";";
        });
        UpdateQueryString("filter", filterText);
        resetToFirstPage()
        haiveFind(query__text, filterText);
    });
    //click sort order dropdown
    $("html").on("click", ".searchresult__meta__dropdown-button", function(e) {
        $(this).toggleClass("open");
        $(this).parent().find(".dropdown-menu").toggle();
    });
    //Click selected sort order
    $("html").on("click", ".searchresult__meta__dropdown-content span", function(e) {
        sort__order = $(this).text() == "Dato" ? "DATE" : "RELEVANCE";
        UpdateQueryString("sort__order", sort__order);
        resetToFirstPage();
        haiveFind(query__text, filterText);
        $(".searchresult__meta__dropdown-button").toggleClass("open");
        $(".searchresult__meta__dropdown").find(".dropdown-menu").toggle();
    });

    //Pagination button click
    $("html").on("click", ".searchresult__pagination a", function(e) {
        if ($(this).hasClass("searchresult__prev__page")) {
            hits__from = Number(prev__page);
        }
        else if ($(this).hasClass("searchresult__next__page")) {
            hits__from = Number(next__page);
        }
        prev__page = Number(hits__from) - Number(hits__pr__page);
        next__page = Number(hits__from) + Number(hits__pr__page);

        UpdateQueryString("hits__from", hits__from);
        haiveFind(query__text, filterText);
        var elmnt = document.getElementById("mainCol");
        elmnt.scrollIntoView();
    });

    //Infinite Scroll
    if (config.InfinityScroll) {
        document.addEventListener('scroll', function(e) {
            if (scrollTimer)
                window.clearTimeout(scrollTimer);

            scrollTimer = window.setTimeout(function() {
                // Fetch variables
                var scrollTop = $(document).scrollTop();
                var windowHeight = $(window).height();
                var bodyHeight = $(document).height() - windowHeight;
                var scrollPercentage = (scrollTop / bodyHeight);

                // if the scroll is more than 90% from the top, load more content.
                if (scrollPercentage > 0.75) {
                    // Load content
                    hits__from = Number(next__page);
                    next__page = Number(hits__from) + Number(hits__pr__page);
                    haiveFind(query__text, filterText);
                }
            }, 150); //only fire every 150 ms.
        });
    }

    haiveFind(query__text, filterText);
    haiveCategorize(query__text);

}

export const getMetadataValue = (result, metakey) => {
    const [metadata] = result.metadata.filter(function(elem) {
        return elem.name === metakey;
    });

    return ((metadata != null) ? ((metadata.value === "") ? "" : metadata.value) : "");

}

const haiveFind = (query__text, filter) => {
    var queryFilter = BuildQueryFilter(filter);

    var query = ` query {      
                    index {
                        items (
                            filter: {
                                searchQuery: "` + query__text + `",       
                                skip: ${hits__from},
                                take: ${hits__pr__page},
                                queryType: MATCHANY,
                                sortBy: ${sort__order.toUpperCase()},
                                categories: ${queryFilter}
                            }                 
                        )    
                        {
                            hits,results {
                                title, date, content, id, url, relevance, extracts, 
                                metadata {
                                    name, value
                                },
                                categories {
                                    values
                                }
                            }
                        }
                    } 
                }`;
    $.ajax({
        type: "POST",
        headers: {
            "ApiKey": 'f28f2f36-d7d7-4b23-a2d3-1d8ec34c4b45',
            "Content-Type": "application/graphql"
        },
        url: searchEngine,
        data: query,
        success: function(data) {
            DisplaySearchResult(data)
        }
    });

}
const haiveCategorize = (query__text, filter) => {
    var queryFilter = BuildQueryFilter(filter);

    $.ajax({
        type: "POST",
        headers: {
            "ApiKey": 'f28f2f36-d7d7-4b23-a2d3-1d8ec34c4b45',
            "Content-Type": "application/graphql"
        },
        url: searchEngine,
        data: ` query {      
                    index {
                        categories (
                            filter: {
                                searchQuery: "` + query__text + `",
                                categories:  ${queryFilter}
                            }                 
                        )    
                        {
                            results {
                                categoryDisplayName
                                groupName
                                groupDisplayName
                                path
                                itemsCount  
                            }
                        }
                    } 
                }`,
        success: function(data) {
            DisplayCategories(data)

            if ($(document).width() < 768) {
                //Close all categories
                $(".categories__listheader").toggleClass("closed")
                $(".categories__listheader").parent().find(".categories__listgroup").toggle();
            }
        }
    });
}
const DisplaySearchResult = (data) => {
    $(".lds-ellipsis").remove();
    if (!config.InfinityScroll) {
        $(".searchresult__list").html("");
    }

    data = data.data;
    $(".searchheader__inputfield").val(query__text);

    if (config.showCategories) {
    //if (true) {
        document.getElementById("leftCol").style.display = "block";
        document.getElementById("mainCol").className = "col-12 col-md-9";
    }
    else {
        document.getElementById("leftCol").style.display = "none";
        document.getElementById("mainCol").className = "col-12";
    }


    if (checkNested(data, "index", "items")) {

        const hits = data.index.items.hits;

        $.each(data.index.items.results, function(snumber, result) {

            let itemLayout = "";
            let debug = false;

            if (query__text.includes(":intellidebug"))
                debug = true;
            if (result.id == null)
                $(".searchresult__list").append(formatDebugItem(result));
            else if (!result.id.includes("Content"))
                itemLayout = formatStatsItem(result.extracts);
            else {
                let id = getMetadataValue(result, "ContentId");

                let date = new Date(result.date);
                let pDate = ('0' + date.getDate()).slice(-2) + '.' +
                    ('0' + (date.getMonth() + 1)).slice(-2) + '.' +
                    date.getFullYear();

                let pageType = getMetadataValue(result, "PageTypeId");
                pageType = pageType == "" ? "file" : pageType;
                const filePath = getMetadataValue(result, "Path");
                const startDebugExtract = result.extracts.indexOf("<hr>", 0);


                let debugExtract = startDebugExtract > -1 ? result.extracts.substring(startDebugExtract).split("<b>").join("<br/><b>") : "";
                let extract = startDebugExtract == -1 ? result.extracts : result.extracts.substring(0, startDebugExtract);
                extract = extract.length < 1 ? result.content.substr(0, 500) + (result.content.length > 500 ? "..." : "") : extract;



                switch (pageType) {
                    case "mal_enhetsmal":
                        itemLayout = `
                        <div data-nr='${snumber}' class="searchresult__list__item">
                            <div class="searchresult__list__mal_enhetsmal">
                                <h3 class="searchresult__list__title">
                                    <a href="/artikkel/${id}" class="searchresult__list__link">${result.title}</a>
                                </h3>
                                <p class="searchresult__list__desc">${extract + debugExtract}</p>
                                <p class="searchresult__list__date">${language("SEARCH_LASTMODIFIED_LABEL")}: ${pDate}</p>
                            </div>
                        </div>`;
                        break;
                    case "mal_visittkort":
                        itemLayout = `
                        <div data-nr='${snumber}' class="searchresult__list__item">
                            <div class="searchresult__list__mal_visittkort">
                                <div class="searchresult__list__profile-icon">
                                    <span class="budlight-profile-picture"></span>
                                </div>
                                <div class="searchresult__list__profile-data">
                                    <h3 class="searchresult__list__title">
                                        <a href="/artikkel/${id}" class="searchresult__list__link">${result.title}</a>
                                    </h3>
                                    <p class="searchresult__list__desc">${ getMetadataValue(result, "personStilling") }</p>
                                    <p class="searchresult__list__desc">${ getMetadataValue(result, "personMobil") }</p>
                                    <p class="searchresult__list__desc">${ getMetadataValue(result, "personEpost") }</p>
                                    ${(debug===true) ? "<p class='searchresult__list__desc'>" + result.extracts.substring(result.extracts.indexOf("<hr>", 0)).split("<b>").join("<br/><b>") + "</p>" : ""} 
                                </div>
                            </div>
                        </div>`;
                        break;
                    case "file":
                        itemLayout = `
                        <div data-nr='${snumber}' class="searchresult__list__item">
                                <h3 class="searchresult__list__title"><span class="icon budlight-file"></span>
                                    <a href="${filePath}" class="searchresult__list__link">${result.title}</a>
                                </h3>
                                <p class="searchresult__list__desc">${(extract!=null?extract:"") + debugExtract}</p>
                                <p class="searchresult__list__date">${language("SEARCH_LASTMODIFIED_LABEL")}: ${pDate}</p>
                        </div>`;
                        break;
                    default:
                        itemLayout = `
                        <div data-nr='${snumber}' class="searchresult__list__item">
                                <h3 class="searchresult__list__title">
                                    <a href="/artikkel/${id}" class="searchresult__list__link">${result.title}</a>
                                </h3>
                                <p class="searchresult__list__desc">${extract + debugExtract}</p>
                                <p class="searchresult__list__date">${language("SEARCH_LASTMODIFIED_LABEL")}: ${pDate}</p>
                        </div>`;
                }
            }
            $(".searchresult__list").append(itemLayout);

        });

        if ($(document).width() < 768) {
            var destination = $('.categories');
            $(".searchresult__meta__count").insertBefore(destination);
        }

        $(".searchresult__meta__count").html(`${language("SEARCH_NUMHITS")}: ${hits}`)
        $(".searchresult__meta__dropdown-content").html(`<li><span>${language("SEARCH_RELEVANCE")}</span></li><li><span>${language("SEARCH_DATE")}</span></li>`);
        if (!config.InfinityScroll) {
            $(".searchresult__pagination").html(`<a Xhref="/search/${query__text}?${filterText!=null?"filter="+filterText+"&":""}hits__from=${Number(prev__page)}${sort__order!="" ? "&sort__order="+sort__order:""}" class="searchresult__prev__page ${hits__from!=0 ? "" : "disabled"}">❮</a><a Xhref="/search/${query__text}?${filterText!=null?"filter="+filterText+"&":""}hits__from=${Number(next__page)}${sort__order != "" ? "&sort__order="+sort__order:""}" class="searchresult__next__page ${hits>next__page ? "" : "disabled"}">❯</a>`);
        }


        if (hits === 0) {
            $(".searchresult__meta").html(`
                    <div class="searchresult__count">${language("SEARCH_TOTALHITS")}: 0</div>
                    <div class="searchresult__showcount">${language("SEARCH_NOHITS_DESC")}</div>
                `)
            $(".searchresult__pagination").html("");
        }

    }

    $("#currentPageBreadcrumb").text(document.title);
    $(".header__search__input").val(query__text);
    $(".searchresult__meta__choosedtxt").html(`${sort__order.toUpperCase()==="DATE" ? "Dato" : "Relevans"}`);
}
const DisplayCategories = (data) => {
    data = data.data;
    let currentGroup = "";
    $.each(data.index.categories.results, function(snumber, result) {
        let hiddenGroups=["contentsubscribers" , "subscriptionid" , "language", "categories", "filetype"];
        if (!hiddenGroups.includes(result.groupName.toLowerCase())) {
            var translatedGroupName = language("SEARCH_" + result.groupDisplayName.toUpperCase());
            var translatedCategoryName = language("SEARCH_CAT_" + result.categoryDisplayName.toUpperCase());

            if (currentGroup != result.groupName) {
                let catHead = `<div class="categories__group">
                    <h4 class="categories__listheader">
                        <div class="categories__listheaderlink">
                        <span>${!translatedGroupName.startsWith("SEARCH_") ? translatedGroupName : result.groupDisplayName}</span>
                        <span class="icon budlight-arrow-top"></span>
                        </div>
                    </h4>
                    <ul class="categories__listgroup list-group" data-category_group="${result.groupName}" ></ul></div>`;
                $(".categories__collection").append(catHead);
            }
            else {

            }
            currentGroup = result.groupName;
            let filter = getUrlAttr("filter");
            let isSelected = false;
            if (filter != null) {
                isSelected = getUrlAttr("filter").includes(result.path.join('|'));
            }
            if (result.path.length < 3) {
                let groupItem = `
                    <li class="list-group-item justify-content-between categories__listitem">
                    <div class="categories__listitem__checkbox">
                        <label>
                        <input type="checkbox" class="categories__listcheck" ${isSelected?"checked":""} data-category_group="${result.groupName}" data-category_select="${result.path.join('|')}"/><span class="checkmark"></span>${!translatedCategoryName.startsWith("SEARCH_CAT_") ? translatedCategoryName : result.categoryDisplayName} (${result.itemsCount})
                        </label>
                    </div>
                    </li>
                `;
                $(".categories__listgroup[data-category_group='" + currentGroup + "']").append(groupItem);
            }
        }
    });
}

const formatDebugItem = (item) => {
    return `
        <h2>` + item.title + `</h2>` +
        item.extracts.split("<b>").join("<br/><b>") + "<br/><br/>";
}
const formatStatsItem = (item) => {
    let regexp_old = /version:\s(?<ver>.*) Total no of items:\s*(?<items>.*) Active items:\s*(?<active>.*) Deleted items:\s*(?<deleted>.*) Last item id:\s*(?<lastid>.*) Last item date:\s*(?<lastitemdate>.*) Memory working set:\s*(?<memworking>.*) Free memory:\s*(?<memfree>.*) Threads in use:\s*(?<threads>.*) Index diskspace usage:\s*(?<diskusage>.*) Free space on index drive:\s*(?<diskfree>.*) Physical processors:\s*(?<processors>.*) Physical cores:\s*(?<cores>.*) Logical cores:\s*(?<coreslogical>.*) OS version:\s*(?<osver>.*) 64bit OS:\s*(?<os64bit>.*) \d{2}bit process:\s*(?<proc64bit>.*)\.NET version:\s*(?<netver>.*) Current directory:\s*(?<dir>.*) Machine name:\s*(?<machine>.*) User:\s*(?<user>.*) \[Interactive:\s*(?<interactive>.*)\]/i;
    let regexp = /version:\s(?<ver>.*?)<.*Total no of items:\s*(?<items>.*?)<.*Active items:\s*(?<active>.*?)<.*Deleted items:\s*(?<deleted>.*?)<.*Last item id:\s*(?<lastid>.*?)<.*Last item date:\s*(?<lastitemdate>.*?)<.*Memory working set:\s*(?<memworking>.*?)<.*Free memory:\s*(?<memfree>.*?)<.*Threads in use:\s*(?<threads>.*?)<.*Index diskspace usage:\s*(?<diskusage>.*?)<.*Free space on index drive:\s*(?<diskfree>.*?)<.*Physical processors:\s*(?<processors>.*?)<.*Physical cores:\s*(?<cores>.*?)<.*Logical cores:\s*(?<coreslogical>.*?)<.*OS version:\s*(?<osver>.*?)<.*64bit OS:\s*(?<os64bit>.*?)<.*\d{2}bit process:\s*(?<proc64bit>.*?)<.*\.NET version:\s*(?<netver>.*?)<.*Current directory:\s*(?<dir>.*?)<.*Machine name:\s*(?<machine>.*?)<.*User:\s*(?<user>.*?) \[Interactive:\s*(?<interactive>.*?)\]/i;

    let matchObj = regexp.exec(item);

    return `
    <h2>Index statistics</h2>
    <table>
        <tr><th>Product version:</th><td>` + matchObj[1] + `</td></tr>
        <tr><th>Total items:</th><td>` + matchObj[2] + `</td></tr>
        
        <tr><th>Active items:</th><td>` + matchObj[3] + `</td></tr>
        <tr><th>Deleted items:</th><td>` + matchObj[4] + `</td></tr>
        <tr><th>Last item id:</th><td>` + matchObj[5] + `</td></tr>
        <tr><th>Last item date:</th><td>` + matchObj[6] + `</td></tr>
        <tr><th>Memory working set:</th><td>` + matchObj[7] + `</td></tr>
        <tr><th>Free memory:</th><td>` + matchObj[8] + `</td></tr>
        <tr><th>Threads in use:</th><td>` + matchObj[9] + `</td></tr>
        <tr><th>Index diskspace usage:</th><td>` + matchObj[10] + `</td></tr>
        <tr><th>Free space on index drive:</th><td>` + matchObj[11] + `</td></tr>
        <tr><th>Physical processors:</th><td>` + matchObj[12] + `</td></tr>
        <tr><th>Physical cores:</th><td>` + matchObj[13] + `</td></tr>
        <tr><th>Logical cores:</th><td>` + matchObj[14] + `</td></tr>
        <tr><th>OS version:</th><td>` + matchObj[15] + `</td></tr>
        <tr><th>64bit OS:</th><td>` + matchObj[16] + `</td></tr>
        <tr><th>64bit process:</th><td>` + matchObj[17] + `</td></tr>
        <tr><th>.NET version:</th><td>` + matchObj[18] + `</td></tr>
        <tr><th>Current directory:</th><td>` + matchObj[19] + `</td></tr>
        <tr><th>Machine name:</th><td>` + matchObj[20] + `</td></tr>
        <tr><th>User:</th><td>` + matchObj[21] + `</td></tr>
        <tr><th>Interactive:</th><td>` + matchObj[22] + `</td></tr>
    </table><br/>
    `

}
const BuildQueryFilter = (filter) => {
    var queryFilter = `[ { values: ["contentSubscribers", "${config.clientId}"] },`;

    //Add filter on language
    if (client.lang == undefined) {
        client.lang = "nb";
    }
    queryFilter += ` { values: ["Language", "${client.lang}_no"] }`;

    if (filter != null) {
        filter.split(";").forEach(function(filterPart, index) {
            if (filterPart != "") {
                queryFilter += `{ values: ["${filterPart.split("|")[0]}", "${filterPart.split("|")[1]}"] },`;
            }
        });
    }
    queryFilter += `]`;

    return queryFilter;
}
const resetToFirstPage = () => {
    hits__from = 0;
    prev__page = Number(hits__from) - Number(hits__pr__page);
    next__page = Number(hits__from) + Number(hits__pr__page);
    $(".searchresult__list").html("");
    UpdateQueryString("hits__from", hits__from);
}
